import { LocalStorageService } from 'src/app/core/localstorage.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-software-components',
  templateUrl: './software-components.component.html',
  styleUrls: ['./software-components.component.scss']
})
export class SoftwareComponentsComponent implements OnInit {
  loginData: boolean = false;

  constructor(private localStorage: LocalStorageService) {
    if(this.localStorage.getFromStorage('userDetails')){
      this.loginData = true;
     }
   }

  ngOnInit() {
  }

}
